export default "__VITE_ASSET__Dbmi7AEi__"